import React from "react";
import Topbar from "../../components/topbar/topbar";
import Footer from "../../components/footer/footer";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import "./index.css";
export default function ThankYou() {
   const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    // check if current route is /payment-cancelled
    if (location.pathname === "/thank-you-page") {
      navigate("/"); // redirect to main route
  }else{
     navigate("/");
  }
  };
  return (
    <>
      <Topbar />
       <div className="thankyou-container">
      <div className="thankyou-card">
        <img
          src="/images/Union-icon.png"
          alt="Union Icon"
          className="thankyou-icon"
        />

        <h2>Thank you!</h2>

        <p className="thankyou-text">
          You have successfully made the payment. If the window doesn't close
          automatically, Please click the button below.
        </p>

        <button className="rounded-btn"  onClick={handleClick}>Click here</button>
      </div>
    </div>

    </>
  );
}
